// Skills are always viewed under "/skill/:slug" (the workspace was merged into the Home feed, so the
// old "/dashboard/skill/:slug" prefix no longer exists). This hook returns a builder for in-skill
// links (suggest, suggestion detail, fork parent, …) so callers don't hard-code the prefix.
// Usage:  const skillPath = useSkillPath();  skillPath(slug)  →  "/skill/foo"
//         skillPath(slug, "/suggest")  ·  skillPath(slug, "?tab=suggestions")
export function useSkillPath(): (slug: string, sub?: string) => string {
  return (slug: string, sub = "") => `/skill/${slug}${sub}`;
}
